<template>
  <div class="d-flex align-center">
    <v-btn elevation="0" :color="color" @click="handleClick" :disabled="disabled"
      :class="[customClass]" :style="{
        padding: `0!important`,
        height: size ? `${size}px!important` : `30px!important`,
        minWidth: size ? `${size}px!important` : `30px!important`,
        border: isActive ? `2px solid #178217!important` : `2px solid #272727!important`,
        cursor: disabled ? `not-allowed` : `pointer`,
        backgroundColor: disabled ? `#EEEEEE!important` : `#FAFAFAt!important`,
    }">
      <svg v-if="isActive" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="18" height="18"
        viewBox="0 0 24 24">
        <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
      </svg>
      <svg v-if="isFiled" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="18" height="18"
        viewBox="0 0 24 24">
        <path
          d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" />
      </svg>
      <span v-if="text && !isActive && !isFiled" class="text-caption blue--text">{{ text }}</span>
    </v-btn>
    <span v-if="label" class="text-caption pl-2">{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    size: String,
    color: String,
    text: String,
    label: String,
    disabled: Boolean,
    isFiled: Boolean,
    isActive: Boolean,
    customClass: String,
    customStyle: String,
  },
  data() {
    return {
    };
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>
